//add color and bar padding properties
import { CommonSchemaIds } from "./common.const.js";
import { ReportConfigurationSchemaIds, ReportConfigurationTags } from "./configuration.const.js";
export const REPORT_CONFIGURATION_TLMD_SCHEMAS = {
    [ReportConfigurationSchemaIds.REPORT_CONFIGURATION]: {
        id: ReportConfigurationSchemaIds.REPORT_CONFIGURATION,
        schema: {
            unevaluatedProperties: false
        },
        properties: {
            range: {
                ref: CommonSchemaIds.RANGE,
                required: true,
                usage: [{ tag: ReportConfigurationTags.DEFAULT }, { tag: ReportConfigurationTags.EXPORT }]
            }
        }
    }
};
